import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '4all-ui/components/Box';
import Select from '4all-ui/components/Select';
import { STATUS, HOURS } from '../../../helpers/constants';
import HelperStatus from '../../../helpers/status';
import * as styles from './style';

const SearchBox = ({
  searchStatus,
  searchOrders,
  searchOrdersByStatus,
  searchOrdersByHours,
  selectStatus,
  searchHours,
  setHoursSelected,
  idOrderSelected,
  orders,
  searchText,
  onSearchText,
  setSearchText,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(STATUS[0]);
  const [selectedHour, setSelectedHours] = useState(HOURS[0]);

  const onSearchInputText = text => {
    onSearchText({ text, setSearchText, searchOrders });
  };

  const onChangeStatus = newSearchStatus => {
    setSelectedStatus(newSearchStatus);
    selectStatus({ searchOrdersByStatus, searchStatus: newSearchStatus, searchHours });
  };

  const onChangeHours = newSearchHours => {
    setSelectedHours(newSearchHours);
    setHoursSelected({ searchOrdersByHours, searchStatus, searchHours: newSearchHours });
  };

  return (
    <Box
      colSize={4}
      customStyles={{
        marginBottom: '20px',
      }}
    >
      <styles.Container>
        <styles.filtersHeader>Filtros</styles.filtersHeader>

        <div className="form-search">
          <styles.InputContainer>
            <styles.SearchInput
              onChange={e => {
                onSearchInputText(e.target.value);
              }}
              minLength={2}
              debounceTimeout={500}
              type="text"
              value={searchText}
              placeholder="Buscar pelo código ou pelo nome do cliente"
              id="search-text"
            />
            <span className="icon-search" />
          </styles.InputContainer>

          <Select
            options={STATUS.map(status => HelperStatus.addDotInformation(status))}
            value={HelperStatus.addDotInformation(selectedStatus)}
            onChange={value => {
              onChangeStatus(value);
            }}
            closeMenuOnSelect
            containerCustomStyles={{
              marginBottom: '10px',
            }}
            optionsListHeight="200px"
            id="search-status"
          />

          <Select
            options={HOURS}
            value={selectedHour}
            onChange={value => {
              onChangeHours(value);
            }}
            closeMenuOnSelect
            optionsListHeight="200px"
            id="search-hour"
          />
        </div>
      </styles.Container>
    </Box>
  );
};

SearchBox.propTypes = {
  searchStatus: PropTypes.object,
  searchOrdersByStatus: PropTypes.func.isRequired,
  searchOrders: PropTypes.func.isRequired,
  selectStatus: PropTypes.func,
  searchHours: PropTypes.object,
  setHoursSelected: PropTypes.func.isRequired,
  idOrderSelected: PropTypes.number,
  orders: PropTypes.array,
  onSearchText: PropTypes.func,
  setSearchText: PropTypes.func.isRequired,
};

SearchBox.defaultProps = {
  searchStatus: {},
  selectStatus: null,
  searchHours: {},
  idOrderSelected: null,
  orders: [],
  onSearchText: {},
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/OrderList/SearchBox/index.js